import "./App.css";
import React from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/routes/PrivateRoute";
import TopNav from "./components/shared/bars/TopNav";
import { routes } from "./data/constants";

import Authentication from "./pages/Authentication";
import Transactions from "./pages/Transactions";
import Users from "./pages/Users";
import AuthCallback from "./components/AuthCallback";

function App() {
  console.log("v-0.0.1");

  return (
    <div className="App">
      <BrowserRouter>
        <TopNav>
          <Routes>
            <Route path={routes.signin} element={<Authentication />} />
            <Route element={<PrivateRoute />}>
              <Route path={routes.base} element={<Transactions />} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path={routes.users} element={<Users />} />
            </Route>
            <Route path="/auth/callback" element={<AuthCallback />} />
          </Routes>
        </TopNav>
      </BrowserRouter>
    </div>
  );
}

export default App;
